var _rect, _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFavIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 39,
    height: 39,
    viewBox: "0 0 39 39",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.773842,
    y: 0.773842,
    width: 37.1444,
    height: 37.1444,
    rx: 18.5722,
    stroke: "#FCC436",
    strokeWidth: 1.54768
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.445 31.2987C19.3342 31.2987 19.2252 31.2703 19.1285 31.2161C17.1597 30.0629 15.3119 28.7145 13.6131 27.1914C9.88846 23.8393 8 20.4987 8 17.2624C8.00038 15.9229 8.43014 14.6187 9.22619 13.5414C10.0222 12.4641 11.1427 11.6704 12.423 11.2767C13.7033 10.883 15.0762 10.9101 16.34 11.3539C17.6038 11.7978 18.6921 12.6352 19.445 13.743C20.1979 12.6352 21.2862 11.7978 22.55 11.3539C23.8138 10.9101 25.1867 10.883 26.467 11.2767C27.7473 11.6704 28.8678 12.4641 29.6638 13.5414C30.4599 14.6187 30.8896 15.9229 30.89 17.2624C30.89 20.4987 29.0015 23.8393 25.2769 27.1914C23.5781 28.7145 21.7303 30.0629 19.7615 31.2161C19.6648 31.2703 19.5558 31.2987 19.445 31.2987Z",
    fill: "#FCC436"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgFavIcon);
export default __webpack_public_path__ + "static/media/favIcon.dd98ca135a8073d110b41efcc357fec6.svg";
export { ForwardRef as ReactComponent };